import React from 'react';
import { Calendar, Briefcase, Award, Code } from 'lucide-react';
import GradientStatCard from './GradientStatCard';
import { colors } from './constants';

const DemographicStats = ({ statistics }) => (
  <div>
    <h2 className="text-lg font-semibold text-gray-800 mb-3 flex items-center">
      <span className="w-1.5 h-5 bg-orange-500 rounded-sm mr-2"></span>
      Statistiques démographiques
    </h2>
    <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
      <GradientStatCard 
        title="Âge moyen" 
        value={`${statistics.averageAge} ans`} 
        icon={<Calendar />} 
        gradient={colors.gradient.green} 
      />
      
      <GradientStatCard 
        title="Expériences" 
        value={statistics.totalExperiences} 
        icon={<Briefcase />} 
        gradient={colors.gradient.purple} 
      />
      
      <GradientStatCard 
        title="Diplômes" 
        value={statistics.totalDiplomes} 
        icon={<Award />} 
        gradient={colors.gradient.orange} 
      />
      
      <GradientStatCard 
        title="Compétences" 
        value={statistics.totalCompetences} 
        icon={<Code />} 
        gradient={colors.gradient.blue} 
      />
    </div>
  </div>
);

export default DemographicStats;
